module.exports = __webpack_public_path__ + "assets/img/btn-view-8d0a82f8.png";